import { useEffect, useMemo } from 'react'
import { AssetsModule } from '@core/modules/digital-footprint/assets'
import { AppModule } from '@core/modules/app/app.module'
import { DialogService } from '@core/services/dialog'
import { unifiedUsersFilterModule } from '../users.filters'

export const useUsersPage = () => {
    const { loading, data: allAssets } = AssetsModule.useStore()
    const { scanInProgress } = AppModule.useStore()
    const { filter, search } = unifiedUsersFilterModule.useStore()

    const userAssets = useMemo(
        () => allAssets.filter((a) => a.asset_type === 'user'),
        [allAssets]
    )

    const cloudAppAssets = useMemo(
        () => allAssets.filter((a) => a.asset_type === 'cloud_app'),
        [allAssets]
    )

    const filteredUsers = useMemo(
        () => unifiedUsersFilterModule.processData(userAssets, false),
        [userAssets, filter, search]
    )

    useEffect(() => {
        return () => {
            DialogService.hideDialog('asset-details-dialog').catch(console.error)
        }
    }, [])

    return {
        loading,
        filteredUsers,
        cloudAppAssets,
        scanInProgress,
        emptyUsersMessage: 'No users found',
    }
}
